/* Les informations suivent le même état que les variantes. Le HTML d'origine reste
 * la référence papier, y compris ses liens et les traductions de l'éditeur Shopify. */
(function () {
  'use strict';
  var originaux = new WeakMap();
  var supportPrecedent = null;
  function original(el) {
    if (!originaux.has(el)) originaux.set(el, {
      html: el.innerHTML, src: el.getAttribute('src'), poster: el.getAttribute('poster'),
      alt: el.getAttribute('alt'), label: el.getAttribute('aria-label'),
      zoom: el.getAttribute('data-src')
    });
    return originaux.get(el);
  }
  function peindre() {
    if (!document.querySelector('#pdp-support')) return;
    var metal = document.documentElement.getAttribute('data-support') === 'metal';
    if (metal === supportPrecedent) return;
    var premierPapier = supportPrecedent === null && !metal;
    supportPrecedent = metal;
    var corps = document.querySelector('#pdp-desc-body[data-metal-description]');
    if (corps && !corps.querySelector('[data-description-metal]')) {
      // L'importeur du catalogue écrit : œuvre, p[data-recherche], fiche technique.
      // On conserve les deux paragraphes sur l'œuvre, dans toutes les langues.
      var recherche = corps.querySelector('p[data-recherche]');
      var technique = recherche && recherche.nextElementSibling;
      if (technique && technique.tagName === 'P' && !technique.nextElementSibling) {
        technique.setAttribute('data-support-only', 'papier');
      }
      var description = document.createElement('p');
      description.setAttribute('data-description-metal', '');
      description.setAttribute('data-support-only', 'metal');
      description.textContent = corps.getAttribute('data-metal-description');
      corps.appendChild(description);
    }
    document.querySelectorAll('[data-metal-text]').forEach(function (el) {
      var o = original(el);
      if (metal) el.textContent = el.getAttribute('data-metal-text');
      else el.innerHTML = o.html;
    });
    document.querySelectorAll('[data-support-only]').forEach(function (el) {
      el.hidden = el.getAttribute('data-support-only') !== (metal ? 'metal' : 'papier');
      if (el.hidden) el.querySelectorAll('video').forEach(function (v) { v.pause(); });
    });
    document.querySelectorAll('[data-metal-src]').forEach(function (el) {
      var o = original(el), src = metal ? el.getAttribute('data-metal-src') : o.src;
      if (premierPapier) return;
      var poster = metal ? el.getAttribute('data-metal-poster') : o.poster;
      var label = metal ? el.getAttribute('data-metal-label') : o.label;
      if (el.tagName === 'VIDEO') {
        if (!o.src) o.src = el.querySelector('source') && el.querySelector('source').getAttribute('src');
        src = metal ? el.getAttribute('data-metal-src') : o.src;
        el.pause();
        if (src) el.setAttribute('src', src);
        if (poster) el.setAttribute('poster', poster); else el.removeAttribute('poster');
        if (label) el.setAttribute('aria-label', label);
        var lecture = el.play();
        if (lecture && lecture.catch) lecture.catch(function () {});
      } else if (el.tagName === 'IMG') {
        if (src) el.setAttribute('src', src);
        if (metal) el.setAttribute('alt', el.getAttribute('data-metal-label') || '');
        else if (o.alt !== null) el.setAttribute('alt', o.alt);
      } else {
        if (metal) el.setAttribute('data-src', el.getAttribute('data-metal-src'));
        else if (o.zoom) el.setAttribute('data-src', o.zoom);
        if (label) el.setAttribute('aria-label', label);
      }
    });
    // Une campagne globale ne prouve pas que les variantes métal sont remisées.
    var variantes = window.__pdpVariants || [];
    var remiseMetal = variantes.some(function (v) {
      return /métal|metal/i.test(v.title) && v.available && Number(v.compare_at_price) > Number(v.price);
    });
    document.documentElement.toggleAttribute('data-metal-sans-promo', metal && !remiseMetal);
    // Le badge du composeur combinait la remise papier à celle du lot.
    document.querySelectorAll('.pdp-create__lot').forEach(function (el) { el.hidden = metal; });
  }
  window.__pdpPeindreContenuSupport = peindre;
})();
